<script lang="ts">
	//Design system components
	import { Container, TemperatureWheel, Text, Toggle } from '@Shelly/shelly-design-system';
	//Svelte stores
	import { createEventDispatcher, getContext } from 'svelte';
	import { format } from 'svelte-i18n';

	export let disabled = false;

	const nightModeStore: SvelteStore<any> = getContext('nightMode');
	const dispatch = createEventDispatcher();

	const hasToggle =
		typeof $nightModeStore?.ct !== 'undefined' && typeof $nightModeStore?.rgb !== 'undefined';

	let ct = $nightModeStore.ct;
	let isEnabled = typeof ct !== 'undefined' && ct !== null;
	let valueRange = $nightModeStore.valueRange || { minValue: 2700, maxValue: 6500 };

	/**
	 * Handles color temperature value changes from the temperature wheel
	 * Updates the local state and dispatches the new value to the parent component
	 *
	 * @param value - number The new color temperature value
	 * @returns void
	 */
	const changeCT = (value) => {
		ct = value;
		dispatch('update', { ct: value });
	};

	/**
	 * Handles the toggle enable/disable state for color temperature
	 * When enabling, sets a default value (middle of range) if ct is null/undefined
	 * When disabling, sets ct to null
	 *
	 * @returns void
	 */
	const handleToggle = () => {
		isEnabled = !isEnabled;
		if (isEnabled) {
			if (ct === null || ct === undefined) {
				const defaultCT = Math.round((valueRange.minValue + valueRange.maxValue) / 2);
				ct = defaultCT;
				dispatch('update', { ct: defaultCT });
			} else {
				dispatch('update', { ct });
			}
		} else {
			dispatch('update', { ct: null });
		}
	};

	const a11yProps = {
		tempWheelAriaLabel: $format('label_color_temperature', { default: 'Color temperature' }),
		thumbAriaLabel: $format('label_color_temperature_thumb', { default: 'Color temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_color_temperature', {
			default: 'Increase color temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_color_temperature', {
			default: 'Decrease color temperature',
		}),
	};
</script>

{#if hasToggle}
	<Toggle id="toggle-zw5rm19" bind:checked={isEnabled} size="m" class="mb-s" on:click={handleToggle}>
		{$format('label_enable')}
	</Toggle>
{/if}
<Container hideSlotTop hideSlotBottom padding="0">
	<Text element="h2" class="mb-s">
		{$format('select_type', {
			values: { type: $format('label_color_temperature') },
		})}
	</Text>
	<TemperatureWheel
		{a11yProps}
		value={ct}
		min={valueRange.minValue}
		max={valueRange.maxValue}
		disabled={!isEnabled || disabled}
		on:value_change={(e) => changeCT(e.detail.value)}
	/>
</Container>
